
$(document).ready(function(){
  $($('#section-id-template--16326891307189__7c40f588-88e8-4501-b3d1-277cc10bebc3').find('.overlay-text__inner')).addClass('scroll-text-custom');
  $($('#section-id-template--16326891307189__7c40f588-88e8-4501-b3d1-277cc10bebc3').find('.overlay-text__button')).addClass('overlay-text__button-custom-asia');
  $($('#shopify-section-template--16326891307189__a4431bb4-1280-4883-a3c9-7b7cf0c77002').find('.majortitle')).addClass('majortitle-custom-asia');
  $($('#shopify-section-template--16326891307189__a4431bb4-1280-4883-a3c9-7b7cf0c77002').find('.cc-animate-init')).addClass('cc-animate-custom-asia');
  $($('#section-id-template--16326891307189__5f0329d8-1c59-4f22-a206-586fe8b42b40').find('.hometitle')).addClass('hometitle-custom-asia');
  $($('#section-id-template--16326891307189__5f0329d8-1c59-4f22-a206-586fe8b42b40').find('.rimage__image')).addClass('rimage__image-custom-asia');
  $($('#section-id-template--16326891307189__5f0329d8-1c59-4f22-a206-586fe8b42b40').find('.text-column__title')).addClass('text-column__title-custom-asia');
  $($('#section-id-template--16326891307189__1650295d-e778-450f-a365-115cb529d33d').find('.column--half')).addClass('column--half-custom-asia');
  $($('#section-id-template--16326891307189__1650295d-e778-450f-a365-115cb529d33d').find('.majortitle')).addClass('majortitle-custom-asia-plan');
  $($('#section-id-template--16326891307189__1650295d-e778-450f-a365-115cb529d33d').find('.lightish-spaced-row-above')).addClass('lightish-spaced-row-above-custom');
  $($('.lightish-spaced-row-above-custom').find('.btn')).addClass('btn-starting_at-custom');
  $($('#section-id-template--16326891307189__1650295d-e778-450f-a365-115cb529d33d').find('ol')).hide();
  $($($('#section-id-template--16326891307189__1650295d-e778-450f-a365-115cb529d33d').find('ol'))).each(function(){
    var starting_at_txt = $(this).find('li')[0].innerHTML;
    var starting_at_price = $(this).find('li')[1].innerHTML;
    var starting_at_logo = $(this).find('li')[2].innerHTML;
    var starting_at_validity = $(this).find('li')[3].innerHTML;
    $(this).parent().append('<div class="starting_at_container">\
        <span class="starting_at_txt">'+starting_at_txt+'</span>\
        <span class="starting_at_price">'+starting_at_price+'</span>\
      </div>\
      <div class="starting_at_logo">\
        <img src="'+starting_at_logo+'">\
      </div>\
      <div class="starting_at_validity">\
        <span class="validity">'+starting_at_validity+'</span>\
      </div>');
    var btnElement = $($($(this).parent()).parent().find('.lightish-spaced-row-above-custom')[0]).detach();
    $(this).parent().append(btnElement[0]);
  });
  $($('#section-id-template--16326891307189__b38a7c9a-dfe6-4e90-b761-f0a7e0ce9729').find('.text-column__image')).addClass('text-column__image-country-custom-asia');
  $($('#section-id-template--16326891307189__b38a7c9a-dfe6-4e90-b761-f0a7e0ce9729').find('.text-column__title')).addClass('text-column__title-country-custom-asia');
  $($('#section-id-template--16326891307189__b38a7c9a-dfe6-4e90-b761-f0a7e0ce9729').find('.column')).addClass('column-country-custom-asia');
  $($('#section-id-template--16326891307189__b38a7c9a-dfe6-4e90-b761-f0a7e0ce9729').find('.column')).append('<div class="country-arrow-custom"><img src="https://cdn.shopify.com/s/files/1/0516/8044/4597/files/right-arrow_430x.png"></div>')
  $($('#block-id-d9afa927-f625-48cf-aaff-236a119cef85').find('.text-column')).addClass('text-column-usage-custom-asia');
  $('.column-country-custom-asia').attr("onclick","clickFlag(this)");
})

$(window).scroll(function() {
  if (!$(".scroll-text-custom").is(':visible')){
    $(".scroll-text-custom").effect( "slide", {direction:"down"}, 1000 );
  }
})

function clickFlag(node){
  window.location.href = $(node).find('.text-column__image-country-custom-asia').find('a').attr('href')
}
